var _path, _path2, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentPin = function SvgCommentPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 1.021c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5H1v-12.5c0-6.903 5.596-12.5 12.5-12.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M13.5 1.021c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5H1v-12.5c0-6.903 5.596-12.5 12.5-12.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.147,
    height: 15.147,
    x: 5.925,
    y: 5.949,
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.448,
    rx: 7.573
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.867 11.31c0-.612.497-1.11 1.11-1.11h5.045c.613 0 1.11.498 1.11 1.11v3.835a1.11 1.11 0 0 1-1.11 1.11h-1.21a.5.5 0 0 0-.404.201l-.666.888a.303.303 0 0 1-.485 0l-.666-.888a.5.5 0 0 0-.403-.201h-1.211a1.11 1.11 0 0 1-1.11-1.11z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.464 9.799h8.072v8.072H9.464z"
  })))));
};
export default SvgCommentPin;